export const shape = { borderRadius: 8 };
//# sourceMappingURL=shape.js.map